// extracted by mini-css-extract-plugin
export var navSwitch = "NavbarToggler-module--navSwitch--15361";